import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Store} from '@ngrx/store';
import {selectedProfile} from '@redux/reducers';
import {isPWAInstalled} from '@shared/util/pwa-util';

@Injectable({
  providedIn: 'root'
})
export class CustomHttpHeaderInterceptorService implements HttpInterceptor {
  userType: string;

  constructor(private _store: Store) {
    this._store.pipe(selectedProfile).subscribe(profile => {
      this.userType = profile?.type;
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const version =  environment.gitTag || environment.gitCommitId;
    let headers = req.headers;
    headers = headers.set('X-Cabanga-Version', version);
    headers = headers.set('pwa-installed', String(isPWAInstalled()));
    if(this.userType)  {
      headers = headers.set('X-User-Type', this.userType);
    }
    const modifiedReq = req.clone({ headers });
    return next.handle(modifiedReq);
  }
}

